<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="error"
      :previous="true"
      title="Aanvraag verzenden"
      :nextColor="[rootStore.theme.actionColor, 'white']"
      @next-step="submitOrder"
      @prev-step="$router.push({ name: 'quoteOrderInvoice' })"
    ></next-prev-menu>
    <div class="card">
      <div class="confirm-card">
        <div class="">
          <description
            :description="order.description"
            @goTo="$router.push({ name: 'quoteOrderDescription' })"
            @addError="addError"
            @removeError="removeError"
          ></description>
          <div class="full" v-if="fileListStore.fileList.length > 0">
            <select-box
              @action="setIncludeFiles"
              :selected="order.includeFiles"
            ></select-box
            ><span @click="setIncludeFiles" class="pointer"
              >{{ fileListStore.fileList.length }} bestand<span
                v-if="fileListStore.fileList.length > 1"
                >en</span
              >
              meesturen met deze offerteaanvraag.</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="confirm-card">
        <div class="card-2col">
          <deliver
            :order="order"
            orderType="deliver"
            @goTo="$router.push({ name: 'quoteOrderDeliver' })"
            :hideDate="true"
          ></deliver>
          <invoice
            :order="order"
            :quote="true"
            @goTo="$router.push({ name: 'quoteOrderInvoice' })"
          ></invoice>
        </div>
      </div>
      <div class="confirm-footer">
        <next-button
          label="Bestelling afronden"
          :disabled="error"
          :background-color="rootStore.theme.actionColor"
          :text-color="'white'"
          @click="submitOrder"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NextButton from '@/components/NextButton.vue'

import Description from '@/components/confirm/Description'
import Deliver from '@/components/confirm/Deliver'
import Invoice from '@/components/confirm/Invoice'
import { useFileListStore } from '@/stores/FileList.store'
import { EventBus } from '@/eventbus/EventBus'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import { useQuoteOrderStore } from '@/features/quoteOrder/QuoteOrder.store'
import { mapStores } from 'pinia'

export default {
  //props: ['order', 'error'],
  data() {
    return {
      totalPrints: 0,
      hideSpecs: false
    }
  },
  components: {
    Description,
    Deliver,
    Invoice,
    NextPrevMenu,
    NextButton
  },
  methods: {
    setIncludeFiles() {
      this.quoteOrderStore.updateOrderDetails(
        'includeFiles',
        !this.order.includeFiles
      )
    },
    submitOrder() {
      EventBus.emit('submitOrder')
    },
    addError(val) {
      this.quoteOrderStore.addOrderError(val)
    },
    removeError(val) {
      this.quoteOrderStore.removeOrderError(val)
    }
  },
  computed: {
    ...mapStores(useQuoteOrderStore, useFileListStore),
    order() {
      return this.quoteOrderStore.orderDetails
    },
    error() {
      return this.quoteOrderStore.orderErrors.length > 0
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.card .card-2col {
  min-height: auto;
}

.card .card-default {
  min-height: auto;
}

.card-list {
  margin-bottom: 10px;
}

.instruction-holder {
  margin: 10px 0;
  white-space: pre-line;
}

.print-file-list {
  li {
    margin-left: 13px;
    margin-right: 13px;
    //border-bottom: 1px solid $list-divider;
    padding: 4px 0;
  }

  li:first-child {
    //padding-top: 0;
  }

  /* 		li:last-child{
			border: none;
		} */

  .file-table {
    display: table;
    table-layout: fixed;
    width: 100%;
    min-height: 56px;
  }

  .file-row {
    display: table-row;
  }
}

.filename-holder {
  display: table-cell;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  padding: 4px 0;
}

.specs-holder {
  text-align: right;
  display: table-cell;
  vertical-align: middle;
}

.template-name {
  padding-left: 7px;
}

.file-spec {
  display: inline-block;
  margin: 0 8px;
  vertical-align: middle;
}

span.file-spec:last-of-type {
  margin-right: 0;
}

.treatment {
  padding-top: 7px;
}
</style>
